import { connect } from 'react-redux'
import ResetPassword from '../components/ResetPassword'
import { reduxForm } from 'redux-form'
import { browserHistory } from 'react-router'

import { generateTokenPassword } from '../../user/UserActions'
import { addNotifSuccess, addNotifError } from '../../notification/NotificationActions'

import request from '../../utils/request'


const config = {
    form: 'ResetPassword',
    onSubmit: (values, dispatch, props) => {
       return dispatch(generateTokenPassword(values)).then(function(){
       		browserHistory.push('/password/confirmation')
       }).catch(function(e){
       		dispatch(addNotifError("Cet email est introuvable.", "Erreur"))
       })
    }
}

export default connect(null, null)(reduxForm(config)(ResetPassword))



// WEBPACK FOOTER //
// ./src/home/containers/ResetPasswordContainer.js